import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Grid, Loader, Message } from "semantic-ui-react";
import { withMedia } from "react-media-query-hoc";
import {
  fetchSettlements,
  settlementManager,
} from "../../../redux/modules/settlement";
import { getUrlParams } from "../../../components/common/urlparams";
import { ErrorWrap } from "../../../helpers/error";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { SettlementTable } from "../../billing/settlement/settlement-table";
import { PageNavigationSimpleFromMeta } from "../../../components/common/page-navigation";
import {
  ContentFilterFormBody,
  settlementQueryFilterParams,
} from "../../billing/settlement/list-content-filter";
import {
  ContentFilterPanel,
  ContentFilterTrigger,
} from "../../../components/common/content-filter";
import { DownloadLink } from "../../../helpers/download-link";
import qs from "qs";
import dayjs from "dayjs";
import { Route } from "react-router-dom";
import { reverseWithSearchParams, routes } from "../../../routes";
import { SettlementModal } from "../../estate/settlement-modal";
import { Switch } from "react-router";
import { t } from "../../../constant/translations";

const StyledContentFilterPanel = styled(ContentFilterPanel)`
  min-height: 550px;
`;

const StyledPageNavigationSimpleFromMeta = styled(PageNavigationSimpleFromMeta)(
  {
    "margin-top": "0!important",
    "margin-bottom": "0!important",
  }
);

const StyledHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const SettlementListComponent = ({ defaultFilters, media }) => {
  const [filterOpen, setFilterOpen] = useState(false);
  const location = useLocation();

  const settlements = useSelector((state) => state.settlement.entities);
  const loading = useSelector((state) => state.settlement.pending);
  const error = useSelector((state) =>
    ErrorWrap.fromError(state.settlement.error)
  );
  const meta = useSelector((state) => state.settlement.meta);
  const dispatch = useDispatch();

  const defaultFiltersObj = {
    page_size: 25,
  };

  const getFilters = () => {
    let argFilters = getUrlParams(location);
    argFilters = { ...argFilters, ...defaultFiltersObj };
    return argFilters;
  };

  const getDownloadRequestParams = () => {
    let argFilters = getFilters();
    argFilters["format"] = "csv";
    return qs.stringify(argFilters, {});
  };

  useEffect(() => {
    dispatch(fetchSettlements(getFilters()));
  }, [location.search]);

  return (
    <Grid padded columns="equal">
      <Grid.Row>
        <Grid.Column>
          <StyledHeader>
            <Switch>
              <Route
                path={routes.settlementDetails}
                render={(routeProps) => {
                  const returnURL = reverseWithSearchParams(
                    routes.settlements + location.search,
                    {
                      settleId: routeProps.match.params.settleId,
                    }
                  );
                  return (
                    <SettlementModal returnURL={returnURL} {...routeProps} />
                  );
                }}
              />
            </Switch>
            <StyledPageNavigationSimpleFromMeta meta={meta} />
            <div>
              <DownloadLink
                size="tiny"
                style={{ float: "right" }}
                href={`/api/settlement?${getDownloadRequestParams()}`}
                basic={true}
                target={"_blank"}
                download={
                  t("settlement.payments") +
                  `-${dayjs().format("YYYY-MM-DD-HHMM")}.csv`
                }
                icon={"download"}
              />
              <ContentFilterTrigger
                style={{ float: "right" }}
                onClick={() => setFilterOpen(!filterOpen)}
                queryParamConfig={settlementQueryFilterParams}
                media={media}
              />
            </div>
          </StyledHeader>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row style={{ padding: "0 0" }}>
        <Grid.Column>
          <div>
            {error.exists() && (
              <Message
                error
                content={error.getGlobal()}
                onDismiss={() =>
                  dispatch(settlementManager.actions.clearError())
                }
              />
            )}
          </div>
          <StyledContentFilterPanel
            open={filterOpen}
            onApply={() => setFilterOpen(false)}
            queryParamConfig={settlementQueryFilterParams}
            FormBody={ContentFilterFormBody}
          >
            <div>
              {loading ? (
                <Loader active={true} />
              ) : (
                <SettlementTable
                  settlements={settlements}
                  estateLink={true}
                  detailsRoute={routes.settlementDetails + location.search}
                />
              )}
            </div>
          </StyledContentFilterPanel>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

SettlementListComponent.propTypes = {
  defaultFilters: PropTypes.object,
  media: PropTypes.object,
};

export const SettlementPage = withMedia(SettlementListComponent);
